module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAABQUlEQVQoU32Su0vDUBTGv2PSSunWUUVsqSIZjGNx8S8wow5CRx1KE8RBNzsLKmntoKOPwdX+BS6aNR3qg9CIVEc3EdumR24ePmrwDvdyvvv94LvnXEK4FKWSfE+8rgNYBaCE8i2As1Qvc9RqVbpCI7FNqBvjCXgNMG6IPJMhLwWX/QZD0gEsSMya06x1KJ8vjw7SuB5gZPfRNi+EMasam+J0bXMvqPVlANupXqZAWVUvgzHrNqulKN4wEEKHAO4FYBG8YtuuP/wH5NTSDEM6FcCLa1fHIvN3JF4E6OqnDvBOLJCb16eZSfttFlUAWAS52Lb3vyL9NQJhpJPYR8cB2Tm9DsJdbFuHgSnVWCHwlt/WaHBJ9C+ZyRKDizrmx2DJIOJCF7LWsQ+efUAsMUAvTWvh15gM5ScA59IbHztO7UNon3Vph4TSeOl2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timeMini.png
// module id = jF0B
// module chunks = 167